<template>
  <div id="app" class="nx-app">
    <router-view />
    <water-mark v-if="website.waterMarkEnable"/>
  </div>
</template>

<script>
import website from "@/config/website";
export default {
  name: "app",
  data() {
    return {
      website
    };
  },
  watch: {},
  created() {
  },
  methods: {
  },

  computed: {}
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.avue--detail .el-col {
  margin-bottom: 0;
}
@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(270deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>
